<template>
  <div>
    <layout menu-item="4">
      <div v-if="loaded" class="inner-container">
        <div layout="row top-left">

          <div layout="row top-left">
            <select class="form-control mb-2" ref="source" @change="changePage($event.target.value)">
              <option v-for="(page, index) in pages" :value="index">{{page.name}}</option>
            </select>

            <button class="btn btn-primary btn-sm ml" @click="copy">- Kopieren ></button>

            <select class="form-control mb-2 ml" ref="target">
              <option v-for="(page, index) in pages" :value="index">{{page.name}}</option>
            </select>
          </div>


          <button class="btn btn-danger" self="right" @click="save">Speichern</button>
        </div>

        <div v-for="element in page.components">
          <component :data="element" v-bind:is="components[element.type].clazz" @up="moveComponent" @down="moveComponent" @remove="removeComponent"/>
        </div>

        <div layout="row center-left">
          <select class="form-control border-primary" @change="setNewComponentType($event.target.value)">
            <option v-for="component in components" :value="component.type">{{component.name}}</option>
          </select>
          <button class="btn btn-primary" style="margin-left: 0.5rem" @click="addComponent">+</button>
        </div>

      </div>

    </layout>
  </div>
</template>

<script>
  import Backend from '@/Backend';
  import CmsShell from "./CmsShell";

  import CmsHeadline from './CmsHeadline';
  import CmsKeyVisual from './CmsKeyVisual';
  import CmsGlobalCountdown from './CmsGlobalCountdown';
  import CmsTextbox from './CmsTextbox';
  import CmsScoreBars from './CmsScoreBars';
  import CmsVideo from './CmsVideo';
  import CmsInstagramGrid from './CmsInstagramGrid';
  import CmsMap from './CmsMap';
  import CmsAddress from './CmsAddress';
  import CmsCityHeadline from './CmsCityHeadline';
  import CmsCars from './CmsCars';
  import CmsSpacing from './CmsSpacing';
  import CmsLocation from './CmsLocation';

  export default {
    components: {CmsShell},
    name: "c-m-s",
    data() {
      return {
        loaded: false,
        pages: [],
        page: null,
        componentType: 0,
        components: [
          {name: 'KeyVisual', type: 0, clazz: CmsKeyVisual},
          {name: 'Headline', type: 1, clazz: CmsHeadline},
          {name: 'Textbox', type: 2, clazz: CmsTextbox},
          {name: 'Countdown', type: 3, clazz: CmsGlobalCountdown},
          {name: 'Score Bars', type: 4, clazz: CmsScoreBars},
          {name: 'Video', type: 5, clazz: CmsVideo},
          {name: 'Instagram Grid', type: 6, clazz: CmsInstagramGrid},
          {name: 'Karte', type: 7, clazz: CmsMap},
          {name: 'CityHeader', type: 8, clazz: CmsCityHeadline},
          {name: 'Autos', type: 9, clazz: CmsCars},
          {name: 'Spacing', type: 10, clazz: CmsSpacing},
          {name: 'Standort', type: 11, clazz: CmsLocation}
        ]
      }
    },
    created() {
      Backend.instance.getPages()
        .then((data) => {
          this.loaded = true;
          this.pages = data;


          const landingPage = data.shift();

          this.pages.sort((a, b) => a.name.localeCompare(b.name));
          this.pages.unshift(landingPage);
          this.page = data[0];

          for (let p of this.pages) {
            for (let i = 0; i < p.components.length; i++) {
              p.components[i].index = i;
            }
          }
        })
        .catch((e) => {

        });
    },
    methods: {
      moveComponent(dir, data) {

        const components = this.page.components;

        console.log('move', data.index, dir);

        if (dir == -1 && data.index == 0) ;
        if (dir == 1 && data.index >= components.length - 1) return;

        const index = data.index;
        const c = components[index + dir];

        console.log(index + dir, data.index, c.index, components.length);

        data.index = c.index;
        c.index = index;

        components.sort((a, b) => {
          return a.index - b.index;
        });

      },
      removeComponent(data) {
        const index = this.page.components.indexOf(data);
        if (index > -1) this.page.components.splice(index, 1);
      },

      copy() {
        const v = confirm('Wirklich kopieren?');
        if (v) {
          const sourceIndex = this.$refs.source.value;
          const targetIndex = this.$refs.target.value;

          if (sourceIndex == targetIndex) return;

          const s = this.pages[sourceIndex];
          const t = this.pages[targetIndex];

          t.components = JSON.parse(JSON.stringify(s.components));
          this.save();
        }
      },

      save() {
        Backend.instance.savePages(this.pages);
      },
      changePage(pageIndex) {
        this.page = this.pages[pageIndex];
      },
      setNewComponentType(value) {
        this.componentType = Number(value);
      },
      addComponent() {
        if (this.page.components == null) this.page.components = [];
        const c = {
          index: this.page.components.length,
          type: this.componentType
        };

        switch (this.componentType) {
          //Headline, Textbox
          case 1:
          case 2:
            c.value = '';
            break;

          //Video
          case 5:
            c.id = '';
            break;

        }

        this.page.components.push(c);
        console.log(this.page.components);
      }
    }
  }
</script>

<style scoped>
  select {
    max-width: 15rem;
  }

  .ml {
    margin-left: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/cms/CMS.vue